import * as THREE from "three";
import { EffectComposer } from "three/examples/jsm/postprocessing/EffectComposer";
import Stats from "stats-js";
import RendererStats from "@xailabs/three-renderer-stats";
import { sample, withLatestFrom, map, filter } from "rxjs/operators";

const RENDERER_GAMMA_FACTOR = 2.2;
// const RENDERER_GAMMA_OUTPUT = true;
// const RENDERER_GAMMA_INPUT = false;
const RENDERER_TONE_MAPPING = THREE.LinearToneMapping;
const RENDERER_TONE_MAPPING_EXPOSURE = 1;
// const RENDERER_TONE_MAPPING_WHITE_POINT = 1;

export const RenderSystem = (
  world,
  { width = 640, height = 480, showStats = false } = {}
) => {
  const renderer = (world.renderer = new THREE.WebGLRenderer({
    // antialias: true,
  }));

  renderer.gammaFactor = RENDERER_GAMMA_FACTOR;
  // .gammaOutput has been removed. Set WebGLRenderer.outputEncoding instead.
  // renderer.gammaOutput = RENDERER_GAMMA_OUTPUT;
  renderer.outputEncoding = THREE.LinearEncoding;
  
  // .gammaInput has been removed. Set the encoding for textures via Texture.encoding instead.
  // renderer.gammaInput = RENDERER_GAMMA_INPUT;

  renderer.toneMapping = RENDERER_TONE_MAPPING;
  renderer.toneMappingExposure = RENDERER_TONE_MAPPING_EXPOSURE;

  // .toneMappingWhitePoint has been removed.
  // renderer.toneMappingWhitePoint = RENDERER_TONE_MAPPING_WHITE_POINT;

  renderer.setSize(width, height);
  renderer.setPixelRatio(window.devicePixelRatio);

  world.canvas = renderer.domElement;
  world.canvas.setAttribute("id", "three");

  const composer = (world.composer = new EffectComposer(renderer));

  const stats = new Stats();
  stats.showPanel(0);
  stats.dom.style.cssText =
    "position:fixed;top:100px;right:0;cursor:pointer;opacity:0.9;z-index:90000";
  showStats && document.body.appendChild(stats.dom);

  const rendererStats = new RendererStats();
  rendererStats.domElement.style.position = "absolute";
  rendererStats.domElement.style.right = "0px";
  rendererStats.domElement.style.top = "148px";
  showStats && document.body.appendChild(rendererStats.domElement);

  world.size$.subscribe((size) => {
    if (size) {
      const { width = 800, height = 600 } = size;
      renderer.setSize(width, height);
      composer.setSize(width, height);
    }
  });

  // draw call stream
  const render$ = (world.render$ = world.change$.pipe(
    filter(e => !world.assetManager.loading),
    sample(world.ticker$),
    withLatestFrom(world.ticker$), // add ticker to stream --> [component, ticker]
    map((item) => item[1]) // [component, ticker] --> ticker
  ));

  // draw
  render$.subscribe((ticker) => {
    showStats && stats.begin();

    // camera controller update
    const hasControlsUpdated = world.cameraControls.update(ticker.delta);
    if (hasControlsUpdated) {
      world.change$.next();
    }

    // update animations
    world.animationManager.update(ticker.delta);

    // renderer.render(world.scene, world.camera);
    composer.render(world.scene, world.camera);
    showStats && stats.end();
    showStats && rendererStats.update(renderer);
  });
};

export default RenderSystem;
